import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Personal from "../views/Personal.vue";
import Quote from "../views/quote/Quote.vue";
import Orderevent from "@/router/orderevent";
import Financial from "@/router/financial";
import Membership from "@/router/membership";
import Search from "@/views/Search.vue"

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "Home",
    component: Home,
    redirect: '/personal', // 设置默认打开的页面
    children: [{
        
        path: '/personal', //首页个人中心
        name: 'Personal',
        component: Personal,
        meta:{
          title: "首页"
        },
      },
      {
        path: '/quote', //智能查价
        name: 'Quote',
        component: Quote,
        meta:{
          title: "智能查价"
        },
      },
      ...Orderevent, ...Financial, ...Membership
    ]
  },
  {
    path: "/login",
    name: "Login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( /* webpackChunkName: "Login" */ "../views/Login.vue"),
    meta: {
      title: "用户登录"
    }
  },
  {
    path: "/search",
    component: Search,
    meta: {
      title: "物流查询"
    }
  },
];
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;